import type { Action } from 'svelte/action';

/**
 * Svelte action to limit the number of characters in a contenteditable element.
 * Usage: <div contenteditable="true" use:limit={30}></div>
 */
export const limit: Action<HTMLElement, number> = (node, maxLength) => {
  const handleBeforeInput = (e: InputEvent) => {
    // 1. Allow deletion of content
    if (e.inputType?.includes('delete')) return;

    // 2. Block input if length is exceeded
    const currentText = node.innerText || '';
    if (currentText.length >= maxLength) {
      e.preventDefault();
    }
  };

  const handlePaste = (e: ClipboardEvent) => {
    e.preventDefault();
    const pasteData = e.clipboardData?.getData('text/plain') || '';
    const currentText = node.innerText || '';
    //  Prevent paste if total would exceed limit
    document.execCommand('insertText', false, pasteData);

    // if (currentText.length + pasteData.length > maxLength) {
    //   const allowedLength = maxLength - currentText.length;

    //   // Insert only the portion that fits
    //   if (allowedLength > 0) {
    //     const truncated = pasteData.substring(0, allowedLength);
    //     document.execCommand('insertText', false, truncated);
    //   }
    // } else {
    //   document.execCommand('insertText', false, pasteData);
    // }
  };

  node.addEventListener('beforeinput', handleBeforeInput as EventListener);
  node.addEventListener('paste', handlePaste as EventListener);

  return {
    update(newLimit: number) {
      maxLength = newLimit;
    },
    destroy() {
      node.removeEventListener(
        'beforeinput',
        handleBeforeInput as EventListener
      );
      node.removeEventListener('paste', handlePaste as EventListener);
    },
  };
};
